import React, { FC, memo } from 'react';
import styled from 'styled-components';
import { CoreTheme as theme } from '@minecraft.themes';
import Icon from '@minecraft.icon';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const StyledIcon = styled(Icon)`
  height: 1.125rem;
  width: 1.125rem;
  margin-right: 0.375rem;
  flex-shrink: 0;
`;

type Props = {
  primaryWorkingLocation: string;
};

const SummaryPrimaryWorkingLocation: FC<Props> = ({ primaryWorkingLocation }) => {
  return (
    !!primaryWorkingLocation && (
      <Container>
        <StyledIcon name="spicerack-location" color={theme.colors.primary.darkGrey} />
        <div>{primaryWorkingLocation}</div>
      </Container>
    )
  );
};

export default memo<Props>(SummaryPrimaryWorkingLocation);
